module.exports = __webpack_public_path__ + "img/success.2c03dc8a.svg";